<template>
    <fragment>
        <div v-if="annotationsWithSameSubjectInConvenion.length > 0">
            <div
                class="indemnity-container"
                v-for="indemnity in annotationsWithSameSubjectInConvenion"
                :key="indemnity._uid"
            >
                <indemnity-details :indemnity="indemnity" :annotationOptions="annotationOptions" />
                <indemnity-description :indemnity="indemnity" />
                <csp-list
                    :cspCodes="indemnity.cspCodes"
                    :conventionCspConfig="convention.cspConfig"
                />
            </div>
        </div>
        <div class="empty-indemnity-container" v-else>
            Absence de dispositions conventionnelles
        </div>
    </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import CspList from "../../../common/CspList.vue";
import IndemnityDetails from "./IndemnityDetails.vue";
import IndemnityDescription from "./IndemnityDescription.vue";

export default {
    props: ["subject", "convention", "annotationOptions"],
    components: {
        Fragment,
        CspList,
        IndemnityDetails,
        IndemnityDescription,
    },
    computed: {
        annotationsWithSameSubjectInConvenion() {
            if (!this.convention.annotationsArray) return [];
            return this.convention.annotationsArray.filter(
                annotation =>
                    annotation["subject"] === this.subject.code &&
                    annotation["type"] === this.subject.type
            );
        },
    },
};
</script>

<style scoped lang="sass">
.indemnity-container
    display: flex
    align-items: center
    padding: 10px 0
    &:not(:last-child)
        border-bottom: 1px solid $color-grey

.empty-indemnity-container
    display: flex
    justify-content: center
    color: $color-grey
</style>
